// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"About_aboutWrapper__xAJw9","leftContainer":"About_leftContainer__QRNn7","rightContainer":"About_rightContainer__Y5CHv"};